export const countryConfig = [
  {
    countryCode: 'AD',
    countryName: 'Andorra',
    hub: 'EPICS',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'AE',
    countryName: 'United Arab Emirates',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'AF',
    countryName: 'Afghanistan',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'AG',
    countryName: 'Antigua and Barbuda',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'AI',
    countryName: 'Anguilla',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'AL',
    countryName: 'Albania',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'AM',
    countryName: 'Armenia',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'AO',
    countryName: 'Angola',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'AQ',
    countryName: 'Antarctica',
    hub: 'Global',
    ageOfMaturity: 16,
    region: 'GLOBAL',
  },
  {
    countryCode: 'AR',
    countryName: 'Argentina',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'AS',
    countryName: 'American Samoa, US',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'AT',
    countryName: 'Austria',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'AU',
    countryName: 'Australia',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'AW',
    countryName: 'Aruba',
    hub: 'Benelux',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'AX',
    countryName: 'Aland Islands',
    hub: 'Nordics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'AZ',
    countryName: 'Azerbaijan',
    hub: 'Turkics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'BA',
    countryName: 'Bosnia and Herzegovina',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'BB',
    countryName: 'Barbados',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'BD',
    countryName: 'Bangladesh',
    hub: 'South Asia',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'BE',
    countryName: 'Belgium',
    hub: 'Benelux',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'BF',
    countryName: 'Burkina Faso',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'BG',
    countryName: 'Bulgaria',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'BH',
    countryName: 'Bahrain',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'BI',
    countryName: 'Burundi',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'BJ',
    countryName: 'Benin',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'BL',
    countryName: 'Saint Barthélemy',
    hub: 'France',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'BM',
    countryName: 'Bermuda',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'BN',
    countryName: 'Brunei',
    hub: 'AGM',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'BO',
    countryName: 'Bolivia',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'BQ',
    countryName: 'Bonaire, Sint Eustatius and Saba',
    hub: 'Benelux',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'BR',
    countryName: 'Brazil',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'BS',
    countryName: 'Bahamas',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'BT',
    countryName: 'Bhutan',
    hub: 'South Asia',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'BV',
    countryName: 'Bouvet Island',
    hub: 'Nordics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'BW',
    countryName: 'Botswana',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'BY',
    countryName: 'Belarus',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'BZ',
    countryName: 'Belize',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'CA',
    countryName: 'Canada',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'CC',
    countryName: 'Cocos (Keeling) Islands',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'CD',
    countryName: 'Congo, the Democratic Republic of the',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'CF',
    countryName: 'Central African Republic',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'CG',
    countryName: 'Congo, the Republic of the',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'CH',
    countryName: 'Switzerland',
    hub: 'EPICS',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'CI',
    countryName: "Cote d'Ivoire",
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'CK',
    countryName: 'Cook Islands',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'CL',
    countryName: 'Chile',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'CM',
    countryName: 'Cameroon',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'CN',
    countryName: 'China',
    hub: 'China',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'CO',
    countryName: 'Colombia',
    hub: 'Colombia',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'CR',
    countryName: 'Costa Rica',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'CU',
    countryName: 'Cuba',
    hub: 'EPICS',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'CV',
    countryName: 'Cape Verde',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'CW',
    countryName: 'Curaçao',
    hub: 'Benelux',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'CX',
    countryName: 'Christmas Island',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'CY',
    countryName: 'Cyprus',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'CZ',
    countryName: 'Czech Republic',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'DE',
    countryName: 'Germany',
    hub: 'Germany',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'DJ',
    countryName: 'Djibouti',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'DK',
    countryName: 'Denmark',
    hub: 'Nordics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'DM',
    countryName: 'Dominica',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'DO',
    countryName: 'Dominican Republic',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'DZ',
    countryName: 'Algeria',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'EC',
    countryName: 'Ecuador',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'EE',
    countryName: 'Estonia',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'EG',
    countryName: 'Egypt',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'EH',
    countryName: 'Western Sahara',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'ER',
    countryName: 'Eritrea',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'ES',
    countryName: 'Spain',
    hub: 'EPICS',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'ET',
    countryName: 'Ethiopia',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'FI',
    countryName: 'Finland',
    hub: 'Nordics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'FJ',
    countryName: 'Fiji',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'FK',
    countryName: 'Falkland Islands (Malvinas)',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'FM',
    countryName: 'Micronesia, Federated States of',
    hub: 'APAC Regional',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'FO',
    countryName: 'Faroe Islands',
    hub: 'Nordics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'FR',
    countryName: 'France',
    hub: 'France',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GA',
    countryName: 'Gabon',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GB',
    countryName: 'United Kingdom',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GD',
    countryName: 'Grenada',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'GE',
    countryName: 'Georgia',
    hub: 'Turkics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GF',
    countryName: 'French Guiana',
    hub: 'France',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GG',
    countryName: 'Guernsey',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GH',
    countryName: 'Ghana',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GI',
    countryName: 'Gibraltar',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GL',
    countryName: 'Greenland',
    hub: 'Nordics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GM',
    countryName: 'Gambia',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GN',
    countryName: 'Guinea',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GP',
    countryName: 'Guadeloupe',
    hub: 'France',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GQ',
    countryName: 'Equatorial Guinea',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GR',
    countryName: 'Greece',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GS',
    countryName: 'South Georgia and the South Sandwich Isl',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GT',
    countryName: 'Guatemala',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'GU',
    countryName: 'Guam, US',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'GW',
    countryName: 'Guinea-Bissau',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'GY',
    countryName: 'Guyana',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'HK',
    countryName: 'Hong Kong',
    hub: 'Hong Kong',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'HM',
    countryName: 'Heard Island and McDonald Islands',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'HN',
    countryName: 'Honduras',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'HR',
    countryName: 'Croatia',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'HT',
    countryName: 'Haiti',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'HU',
    countryName: 'Hungary',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'ID',
    countryName: 'Indonesia',
    hub: 'AGM',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'IE',
    countryName: 'Ireland',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'IL',
    countryName: 'Israel',
    hub: 'EPICS',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'IM',
    countryName: 'Isle of Man',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'IN',
    countryName: 'India',
    hub: 'South Asia',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'IO',
    countryName: 'British Indian Ocean Territory',
    hub: 'APAC Regional',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'IQ',
    countryName: 'Iraq',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'IR',
    countryName: 'Iran, Islamic Republic of',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'IS',
    countryName: 'Iceland',
    hub: 'Nordics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'IT',
    countryName: 'Italy',
    hub: 'Italy',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'JE',
    countryName: 'Jersey',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'JM',
    countryName: 'Jamaica',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'JO',
    countryName: 'Jordan',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'JP',
    countryName: 'Japan',
    hub: 'Japan',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'KE',
    countryName: 'Kenya',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'KG',
    countryName: 'Kyrgyzstan',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'KH',
    countryName: 'Cambodia',
    hub: 'AGM',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'KI',
    countryName: 'Kiribati',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'KM',
    countryName: 'Comoros',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'KN',
    countryName: 'Saint Kitts and Nevis',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'KP',
    countryName: "Korea, Democratic People's Republic of",
    hub: 'APAC Regional',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'KR',
    countryName: 'Korea, Republic of',
    hub: 'Korea',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'KW',
    countryName: 'Kuwait',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'KY',
    countryName: 'Cayman Islands',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'KZ',
    countryName: 'Kazakhstan',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'LA',
    countryName: 'Laos',
    hub: 'AGM',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'LB',
    countryName: 'Lebanon',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'LC',
    countryName: 'Saint Lucia',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'LI',
    countryName: 'Liechtenstein',
    hub: 'EPICS',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'LK',
    countryName: 'Sri Lanka',
    hub: 'AGM',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'LR',
    countryName: 'Liberia',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'LS',
    countryName: 'Lesotho',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'LT',
    countryName: 'Lithuania',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'LU',
    countryName: 'Luxembourg',
    hub: 'Benelux',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'LV',
    countryName: 'Latvia',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'LY',
    countryName: 'Libya',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'MA',
    countryName: 'Morocco',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'MC',
    countryName: 'Monaco',
    hub: 'France',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'MD',
    countryName: 'Moldova, Republic of',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'ME',
    countryName: 'Montenegro',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'MF',
    countryName: 'Saint Martin (French part)',
    hub: 'France',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'MG',
    countryName: 'Madagascar',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'MH',
    countryName: 'Marshall Islands',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'MK',
    countryName: 'North Macedonia',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'ML',
    countryName: 'Mali',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'MM',
    countryName: 'Myanmar',
    hub: 'AGM',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'MN',
    countryName: 'Mongolia',
    hub: 'China',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'MO',
    countryName: 'Macao',
    hub: 'Hong Kong',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'MP',
    countryName: 'Northern Mariana Islands, US',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'MQ',
    countryName: 'Martinique',
    hub: 'France',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'MR',
    countryName: 'Mauritania',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'MS',
    countryName: 'Montserrat',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'MT',
    countryName: 'Malta',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'MU',
    countryName: 'Mauritius',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'MV',
    countryName: 'Maldives',
    hub: 'South Asia',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'MW',
    countryName: 'Malawi',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'MX',
    countryName: 'Mexico',
    hub: 'Mexico',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'MY',
    countryName: 'Malaysia',
    hub: 'AGM',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'MZ',
    countryName: 'Mozambique',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'NA',
    countryName: 'Namibia',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'NC',
    countryName: 'New Caledonia',
    hub: 'France',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'NE',
    countryName: 'Niger',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'NF',
    countryName: 'Norfolk Island',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'NG',
    countryName: 'Nigeria',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'NI',
    countryName: 'Nicaragua',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'NL',
    countryName: 'Netherlands',
    hub: 'Benelux',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'NO',
    countryName: 'Norway',
    hub: 'Nordics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'NP',
    countryName: 'Nepal',
    hub: 'South Asia',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'NR',
    countryName: 'Nauru',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'NU',
    countryName: 'Niue',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'NZ',
    countryName: 'New Zealand',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'OM',
    countryName: 'Oman',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'PA',
    countryName: 'Panama',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'PE',
    countryName: 'Peru',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'PF',
    countryName: 'French Polynesia',
    hub: 'France',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'PG',
    countryName: 'Papua New Guinea',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'PH',
    countryName: 'Philippines',
    hub: 'AGM',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'PK',
    countryName: 'Pakistan',
    hub: 'AGM',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'PL',
    countryName: 'Poland',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'PM',
    countryName: 'Saint Pierre and Miquelon',
    hub: 'France',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'PN',
    countryName: 'Pitcairn',
    hub: 'APAC Regional',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'PR',
    countryName: 'Puerto Rico, US',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'PS',
    countryName: 'Palestine, State of',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'PT',
    countryName: 'Portugal',
    hub: 'EPICS',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'PW',
    countryName: 'Palau',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'PY',
    countryName: 'Paraguay',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'QA',
    countryName: 'Qatar',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'RE',
    countryName: 'Reunion',
    hub: 'France',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'RO',
    countryName: 'Romania',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'RS',
    countryName: 'Serbia',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'RU',
    countryName: 'Russian Federation',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'RW',
    countryName: 'Rwanda',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SA',
    countryName: 'Saudi Arabia',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SB',
    countryName: 'Solomon Islands',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'SC',
    countryName: 'Seychelles',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SD',
    countryName: 'Sudan',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SE',
    countryName: 'Sweden',
    hub: 'Nordics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SG',
    countryName: 'Singapore',
    hub: 'AGM',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'SH',
    countryName: 'Saint Helena, Ascension and Tristan da C',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SI',
    countryName: 'Slovenia',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SJ',
    countryName: 'Svalbard and Jan Mayen',
    hub: 'Nordics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SK',
    countryName: 'Slovakia',
    hub: 'CEE (EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SL',
    countryName: 'Sierra Leone',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SM',
    countryName: 'San Marino',
    hub: 'Italy',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SN',
    countryName: 'Senegal',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SO',
    countryName: 'Somalia',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SR',
    countryName: 'Suriname',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'SS',
    countryName: 'South Sudan',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'ST',
    countryName: 'Sao Tome and Principe',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SV',
    countryName: 'El Salvador',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'SX',
    countryName: 'Sint Maarten (Dutch part)',
    hub: 'Benelux',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SY',
    countryName: 'Syrian Arab Republic',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'SZ',
    countryName: 'Swaziland',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'TC',
    countryName: 'Turks and Caicos Islands',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'TD',
    countryName: 'Chad',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'TF',
    countryName: 'French Southern Territories',
    hub: 'France',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'TG',
    countryName: 'Togo',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'TH',
    countryName: 'Thailand',
    hub: 'AGM',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'TJ',
    countryName: 'Tajikistan',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'TK',
    countryName: 'Tokelau',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'TL',
    countryName: 'Timor-Leste',
    hub: 'APAC Regional',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'TM',
    countryName: 'Turkmenistan',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'TN',
    countryName: 'Tunisia',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'TO',
    countryName: 'Tonga',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'TR',
    countryName: 'Turkey',
    hub: 'Turkics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'TT',
    countryName: 'Trinidad and Tobago',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'TV',
    countryName: 'Tuvalu',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'TW',
    countryName: 'Taiwan',
    hub: 'Taiwan',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'TZ',
    countryName: 'Tanzania',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'UA',
    countryName: 'Ukraine',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'UG',
    countryName: 'Uganda',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'UM',
    countryName: 'United States Minor Outlying Islands',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'US',
    countryName: 'United States',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'UY',
    countryName: 'Uruguay',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'UZ',
    countryName: 'Uzbekistan',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'VA',
    countryName: 'Vatican City, Holy See',
    hub: 'Italy',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'VC',
    countryName: 'Saint Vincent and the Grenadines',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'VE',
    countryName: 'Venezuela',
    hub: 'CLASA Regional',
    ageOfMaturity: 16,
    region: 'CLASA',
  },
  {
    countryCode: 'VG',
    countryName: 'Virgin Islands, British',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'VI',
    countryName: 'Virgin Islands, US',
    hub: 'CAM',
    ageOfMaturity: 16,
    region: 'CAM',
  },
  {
    countryCode: 'VN',
    countryName: 'Vietnam',
    hub: 'AGM',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'VU',
    countryName: 'Vanuatu',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'WF',
    countryName: 'Wallis and Futuna',
    hub: 'APAC Regional',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'WS',
    countryName: 'Samoa',
    hub: 'ANZ',
    ageOfMaturity: 16,
    region: 'APAC',
  },
  {
    countryCode: 'XK',
    countryName: 'Kosovo',
    hub: 'CEE (Non-EU)',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'YE',
    countryName: 'Yemen',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'YT',
    countryName: 'Mayotte',
    hub: 'France',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'ZA',
    countryName: 'South Africa',
    hub: 'Atlantics',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'ZM',
    countryName: 'Zambia',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
  {
    countryCode: 'ZW',
    countryName: 'Zimbabwe',
    hub: 'MEA',
    ageOfMaturity: 16,
    region: 'EMEA',
  },
];
